import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useUsersService } from '../../../../apis/users/useUsersService';
import { TSupervisorsResponse } from '../../../../apis/users/users.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getSupervisorsKey = 'get-supervisors';

export const useSupervisorsHook = (
  instituteId: string
): UseQueryResult<TSupervisorsResponse, TQueryError> => {
  const { getSupervisors } = useUsersService();

  return useQuery<TSupervisorsResponse, TQueryError>({
    queryKey: [getSupervisorsKey, instituteId],
    queryFn: () => getSupervisors(instituteId),
    enabled: true,
  });
};
